import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IContactAddConnectionRequest {
	excludeContactIds?: string[];
	filter?: Api.IContactsFilterRequest;
	ownershipFilter?: Api.IOwnershipFilter;
	includeContactIds?: string[];
	newConnectionId: string;
}

export function useContactAddConnectionMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async (request: IContactAddConnectionRequest) => {
			return new Promise<Api.ISystemJob>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceWithOperationResults<Api.ISystemJob>(
					Api.ImpersonationBroker.composeApiUrl({
						urlPath: 'contact/connection',
					}),
					'POST',
					request,
					result => {
						if (result.success && result.value) {
							resolve(result.value);
						} else {
							reject(result);
						}
					},
					error => reject(error)
				);
			});
		},
		onSuccess,
		onError,
	});
}
